<template>
  <div class="block">
    <el-carousel height="454px">
      <el-carousel-item
        v-for="(item, index) in banners"
        :key="index"
        :style="item.url ? 'cursor: pointer' : ''"
        @click.native="goUrl(item.url)"
      >
        <div id="pic" :style="{ backgroundImage: `url(${item.image})` }"></div>
        <!-- <img :src="item.image" alt="banner"> -->
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    banners: Array
  },
  watch: {
    banners: {
      handler() {},
      deep: true
    }
  },
  methods: {
    goUrl(url) {
      if (url) {
        window.open(url, "_blank");
      }
    }
  }
};
</script>

<style lang="less" scoped>
#pic {
  width: 100%;
  height: 454px;
  background-size: cover;
  background-position: center;
}
.el-carousel /deep/ .el-icon-arrow-left::before {
  content: "\E600" !important;
}
.el-carousel /deep/ .el-icon-arrow-right::before {
  content: "\E604" !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home-banner.vue